export default "__VITE_ASSET__BWWqYNJt__"